import { LoadingOutlined } from '@ant-design/icons';
import { Avatar, Collapse } from 'antd';

import { LoadingSkeleton } from '@/components-ant/loading-skeleton';

import { HorizontallySpaced } from '../../../../../styles/layout';
import { renderCollapseIcon } from './CarrierList';
import { CarrierCollapse } from './styles';

export function LoadingCarrierList() {
  // would make the panels subcomponents, but the expand icon breaks unless they are direct children
  return (
    <CarrierCollapse bordered={false} expandIconPosition="end" expandIcon={renderCollapseIcon}>
      {[1, 2, 3].map((key) => (
        <Collapse.Panel
          key={key}
          header={
            <HorizontallySpaced>
              <Avatar shape="square" icon={<LoadingOutlined spin />} />
              <span>
                <LoadingSkeleton width="200px" />
              </span>
            </HorizontallySpaced>
          }
        />
      ))}
    </CarrierCollapse>
  );
}
